import * as $ from 'jquery';

class FormPopUp {
  init = () => {
    const formModal: HTMLButtonElement = document.querySelector('.resero-modal.resero-modal--form-pop-up');
    
    if (!formModal) {
      return;
    }
    const delayTime = formModal.getAttribute('data-delay') ? formModal.getAttribute('data-delay') : 500;
    

    function handlePopUpClose () {
      $('body').removeClass('resero-modal-open')
      $(formModal).addClass("resero-modal--hidden");
    }

    $(".resero-modal__close:not('.resero-modal__custom-close'), .resero-modal__heading__desc a, .resero-modal__region__item .button:not('.-active')").on("click", handlePopUpClose);

  };

}

const FormPopUpInstance = new FormPopUp();
FormPopUpInstance.init();

export { FormPopUp, FormPopUpInstance };